import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { type ReactNode } from "react";

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  warning?: string;
  confirmText?: string;
  cancelText?: string;
  isDeleting?: boolean;
  error?: string | null;
}

export function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  warning,
  confirmText = "Radera",
  cancelText = "Avbryt",
  isDeleting = false,
  error,
}: DeleteConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="text-red-600" size={24} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
            <div className="text-gray-600 mb-1">{description}</div>
            {warning && <p className="text-sm text-gray-500">{warning}</p>}
            {error && (
              <p className="mt-2 text-sm text-red-600 bg-red-50 p-2 rounded">
                {error}
              </p>
            )}
          </div>
        </div>

        <div className="flex space-x-3 mt-6">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1 btn btn-secondary"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1 btn bg-red-600 text-white hover:bg-red-700 flex items-center justify-center"
          >
            {isDeleting ? (
              <>
                <Loader2 size={18} className="mr-2 animate-spin" />
                Raderar...
              </>
            ) : (
              <>
                <Trash2 size={18} className="mr-2" />
                {confirmText}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
